import '../../../core/components/app-root/AppRoot.css';
import './ActionsMenu.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var actionsMenuWrapper = _7a468({defaultClassName:'_1okebta2-3-15-1',variantClassNames:{size:{'default':'_1okebta3-3-15-1',condensed:'_1okebta4-3-15-1'}},defaultVariants:{size:'default'},compoundVariants:[]});
export var editorWithActionsMenu = {'default':'_1okebta5-3-15-1',condensed:'_1okebta6-3-15-1'};
export var editorWrapper = '_1okebta0-3-15-1';
export var editorWrapperFullHeight = '_1okebta1-3-15-1';
export var formatQueryShortcut = '_1okebta7-3-15-1';